"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide2 = exports.HomepageSlide2 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide2 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      @keyframes parallax-slide-south {
        from {
          transform: translateY(200px);
        }
        to {
          transform: translateY(0);
        }
      }
      
      @keyframes parallax-slide-north {
        from {
          opacity: 0;
          transform: translateY(-100px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @keyframes parallax-slide-east {
        from {
          transform: translateX(-400px);
        }
        to {
          transform: translateX(0);
        }
      }
      
      @keyframes parallax-slide-west {
        from {
          transform: translateX(400px);
        }
        to {
          transform: translateX(0);
        }
      }
      
      :host {
        display: block;
        text-align: center;
        font-size: 1.8rem;
        width: 100%;
        max-width: var(--slide-max-width);
        margin: 5rem auto;
        
        view-timeline-name: --slide-timeline;
        view-timeline-axis: block;
      }
      
      img.double-quote {
       scale: 0.7;
       margin: 0.5rem;
      }
      p {
        margin-bottom: 1.5rem;
        font-family: 'quaaykop-medium', sans-serif;
      }
      
      p.east {
        animation: parallax-slide-east linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 0% entry 100%;
        animation-fill-mode: both;
      }
      
      p.west {
        animation: parallax-slide-west linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 0% entry 100%;
        animation-fill-mode: both;
      }
      
      p.south {
        animation: parallax-slide-south linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 0% entry 100%;
        animation-fill-mode: both;
      }
      
      p.north {
        animation: parallax-slide-north linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 80% entry 100%;
        animation-fill-mode: both;
      }

    </style>
    <img class="double-quote" src="/files/assets/images/double-quote-open.png" alt="" />
    <div class="beyond-stage">
      <p class="north">AiLEENE is more than just a Filler</p>
      <p class="east">What we aim to deliver is not a product, but the essence of your natural beauty</p> 
      <p class="west">The confidence that comes from believing in yourself, the unique light that rise from deep within.</p>
      <p class="south">With AiLEENE, discover your true value-authentic, refined, and unmistakably yours</p>
    </div>
    <img class="double-quote" src="/files/assets/images/double-quote-close.png" alt="" />`;
        // const io = new IntersectionObserver((entries, observer) => {
        //   entries.forEach(entry => {
        //     if (entry.isIntersecting) {
        //       entry.target.classList.replace('beyond-stage', 'on-stage');
        //       observer.unobserve(entry.target);
        //     }
        //   });
        // });
        // shadow.querySelectorAll('.beyond-stage').forEach(el => io.observe(el));
    }
}
exports.HomepageSlide2 = HomepageSlide2;
const defineHomepageSlide2 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide2);
};
exports.defineHomepageSlide2 = defineHomepageSlide2;
